export enum LENS_OPTIONS_TYPES {
    coatings = 'Coatings',
    scratch  = 'Scratch',
    tints    = 'Tints',
    ar       = 'AR'
}


export enum LENS_OPTIONS {
  antifog = 2,
  transitions = 3,
  lightTint = 4,
  darkTint = 5,
  blueLight = 39
}
